/**
 * Scroll Sync for Products and Valeurs pages
 */

function initSyncScroll(sectionSelector, contentSelector, imageSelector) {
    const section = document.querySelector(sectionSelector);
    if (!section) return;
    
    const contentArea = section.querySelector(contentSelector);
    const imageArea = section.querySelector(imageSelector);
    
    if (!contentArea || !imageArea) return;
    
    // Handle wheel events on the entire section
    const handleScroll = (e) => {
        const maxScroll = contentArea.scrollHeight - contentArea.clientHeight;
        const currentScroll = contentArea.scrollTop;
        
        // Check if we're at the boundaries
        const atTop = currentScroll <= 0 && e.deltaY < 0;
        const atBottom = currentScroll >= maxScroll && e.deltaY > 0;
        
        // If at boundaries, allow normal page scroll
        if (atTop || atBottom) {
            return; // Don't prevent default, let page scroll
        }
        
        // Otherwise, prevent default and scroll the content
        e.preventDefault();
        contentArea.scrollTop += e.deltaY;
    };
    
    // Apply to both the section and image area
    section.addEventListener('wheel', handleScroll, { passive: false });
    imageArea.addEventListener('wheel', handleScroll, { passive: false });
}

export function initProductsScroll() {
    initSyncScroll('[data-products-section]', '[data-content-scroll]', '[data-image-scroll]');
}

export function initValeursScroll() {
    initSyncScroll('[data-valeurs-section]', '[data-valeurs-content]', '[data-valeurs-slider]');
}

export function initScroll() {
    initProductsScroll();
    initValeursScroll();
}